"use strict";

exports.__esModule = true;
exports.default = sortBy;
var _cb = _interopRequireDefault(require("./_cb.js"));
var _pluck = _interopRequireDefault(require("./pluck.js"));
var _map = _interopRequireDefault(require("./map.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Sort the object's values by a criterion produced by an iteratee.
function sortBy(obj, iteratee, context) {
  var index = 0;
  iteratee = (0, _cb.default)(iteratee, context);
  return (0, _pluck.default)((0, _map.default)(obj, function (value, key, list) {
    return {
      value: value,
      index: index++,
      criteria: iteratee(value, key, list)
    };
  }).sort(function (left, right) {
    var a = left.criteria;
    var b = right.criteria;
    if (a !== b) {
      if (a > b || a === void 0) return 1;
      if (a < b || b === void 0) return -1;
    }
    return left.index - right.index;
  }), 'value');
}